import 'whatwg-fetch';

import { trackCWV } from 'js/utils';
trackCWV();

if (typeof $auvid === 'undefined') {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  assignGlobal('$auvid', null);
}

import assignGlobal from './util/assign_global';

import { Split } from 'js/core_webpack/metrics/split';
import { loadRecordHit } from 'js/core_webpack/metrics/record_hit';
import { record_browser_timings } from 'js/core_webpack/metrics/record_browser_timings';
import { Kale } from 'js/core_webpack/metrics/kale';
import { set_gmtoffset } from 'js/core_webpack/metrics/gmt_offset';
import {
  track_click,
  loadClickTracking,
} from 'js/core_webpack/metrics/click_tracking';
import { ImpressionWatcher, watchDomImpressions } from 'js/utils/impressions';
import { startTimeTracking } from 'js/core_webpack/metrics/time_on_site_tracking';
import { startActivityTracking } from 'js/core_webpack/metrics/page_activity_tracking';
import { CoreXNav, FocusedNav } from 'js/header';
import { SeasonalDiscountUnibrow } from 'js/liswp/Unibrows';
import AdminBar from 'js/admin_bar/AdminBarActivator';
import { removeLocationSearchParams } from 'js/utils';

import * as a_recaptcha from 'js/core_webpack/a_recaptcha';

import * as DownloadModule from 'js/core_webpack/sitewide_business_elements/download';

import FileUploader from 'js/utils/file_uploader';

import showModal from 'js/components/show_modal.tsx';
assignGlobal('Components.Utils', { showModal });

import recaptchaManagedForm from 'js/core_webpack/recaptcha_managed_form';
assignGlobal('Aedu', { recaptchaManagedForm });

import * as arbitraryEvents from 'js/core_webpack/arbitrary_events';
assignGlobal('Aedu', { arbitraryEvents });

import { registerForRails, trackClick } from 'js/utils';
assignGlobal('Aedu', { trackClick });

assignGlobal('Aedu.Documents', DownloadModule); // may not be needed
assignGlobal('Aedu.Documents.Download', {}); // can't confirm this is used anywhere

assignGlobal('Aedu', { FileUploader });

assignGlobal('Aedu', { Split });

loadRecordHit();

assignGlobal('Aedu', { record_browser_timings });

assignGlobal('Aedu', { a_recaptcha });

assignGlobal('Aedu', { ImpressionWatcher });

window.Kale = Kale;

assignGlobal('Academia', { set_gmtoffset });

assignGlobal('Academia', { track_click });

watchDomImpressions();
loadClickTracking();

startTimeTracking();
startActivityTracking();

import { captureException } from '@sentry/browser';
import { initPromise } from 'js/i18next/initI18next';
initPromise.catch((error) => {
  error.message = `i18next initialization error: ${error.message}`;
  captureException(error);
});

import i18nResources from '@alienfast/i18next-loader?include=**/Global.json!config/locales_i18next/index.js';
import addResources from 'js/i18next/addResources';
addResources(i18nResources, 'Global');

// legacy i18n
import I18n from 'i18n-js';
window.I18n = I18n;
import 'js/i18n/translations/global';

import ReactOnRails from 'react-on-rails/client';
window.ReactOnRails = ReactOnRails;
import React from 'react';
window.React = React;
import ReactDOM from 'react-dom';
window.ReactDOM = ReactDOM;
import ReactMedia from 'react-media';
window.ReactMedia = ReactMedia;
import createReactClass from 'create-react-class';
window.createReactClass = createReactClass;
import Media from 'react-media';
window.Media = Media;
import * as ReactBootstrap from 'react-bootstrap';
Object.assign(window, ReactBootstrap);
import classNames from 'classnames';
window.classNames = classNames;
import moment from 'moment';
window.moment = moment;
import commaizeInt from 'js/utils/commaize';
import $image_url from 'js/utils/image_url';
import { startRecordingIfSamplingRequest } from 'js/fullstory';

import ChurnedUserReactivationUnibrow from 'js/unibrows/churned_user_reactivation';
import PaymentProblemAlertUnibrow from 'js/unibrows/payment_problem_alert';
import AddSecondaryPaymentUnibrow from 'js/unibrows/payment_problem_alert/AddSecondaryPaymentUnibrow';

Object.assign(window, { commaizeInt, $image_url });

// this pulls in a formerly separate and not fully converted sprockets bundle
require('js/application');

startRecordingIfSamplingRequest();

registerForRails({ AdminBar }, [
  'js/admin_bar/AdminBarActivator',
  'js/admin_bar/AdminBar',
]);
registerForRails({ CoreXNav }, ['js/header/CoreXNav/CoreXNav']);
registerForRails({ FocusedNav }, ['js/header/FocusedNav/FocusedNav']);
registerForRails({ SeasonalDiscountUnibrow });
registerForRails({ ChurnedUserReactivationUnibrow });
registerForRails({ PaymentProblemAlertUnibrow });
registerForRails({ AddSecondaryPaymentUnibrow });

import { maybeInitializeQualaroo } from 'js/qualaroo';

maybeInitializeQualaroo();
removeLocationSearchParams('nav_from');
